import { ArrowUpRight } from 'lucide-react';
import { Plate } from '@/components/landing/primitives';
import { stagger } from '@/components/landing/stagger';
import { COMMUNITY } from '@/content/community';

/**
 * The community AGICAFET organizes: the vLLM Bangkok mark in its own colours
 * (it is ours to show, unlike the client marks), one statement, and the stage
 * at vLLM Bangkok Day at full width. The link out is a quiet one — the page's
 * filled buttons all go to PreMize.
 */
export function CommunitySection() {
  return (
    <Plate eyebrow="Community" id="community" labelledBy="community-title">
      <div className="grid items-end gap-10 lg:grid-cols-[6fr_6fr] lg:gap-16">
        <div className="lp-reveal" style={stagger(1)}>
          <img
            loading="lazy"
            decoding="async"
            src="/img/vllm-bangkok-logo.webp"
            width={625}
            height={240}
            alt="vLLM Bangkok Community"
            className="h-20 w-auto md:h-28"
          />
          <h2 id="community-title" className="lp-h2 mt-10 max-w-3xl">
            We organize vLLM Bangkok.
          </h2>
        </div>
        <div className="lp-reveal" style={stagger(2)}>
          <p className="lp-body">{COMMUNITY.line}</p>
          <a
            href={COMMUNITY.url}
            target="_blank"
            rel="noopener noreferrer"
            className="link-quiet mt-6 inline-flex"
          >
            Visit {COMMUNITY.host} <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>

      <figure className="lp-reveal mt-14 md:mt-16" style={stagger(3)}>
        <img
          loading="lazy"
          decoding="async"
          src="/img/vllm-bangkok-day-1600.webp"
          srcSet="/img/vllm-bangkok-day-800.webp 800w, /img/vllm-bangkok-day-1200.webp 1200w, /img/vllm-bangkok-day-1600.webp 1600w, /img/vllm-bangkok-day-2048.webp 2048w"
          sizes="(min-width: 1360px) 1280px, calc(100vw - 2.5rem)"
          width={2048}
          height={1367}
          alt={COMMUNITY.event.alt}
          className="w-full rounded-xl"
        />
        <figcaption className="t-caption mt-3">{COMMUNITY.event.caption}</figcaption>
      </figure>
    </Plate>
  );
}
